export const SEND_MESSAGE = 'appBridge/SEND_MESSAGE';
export const SET_VERSION = 'appBridge/SET_VERSION';
